import { defineStore } from 'pinia'

import type { FeedbackStore } from './interfaces'

import { FeedbackStep, FeedbackSurveyType } from './enums'
import { actions } from './actions'
import { getters } from './getters'

export const useFeedbackStore = defineStore('feedback', {
  state: (): FeedbackStore => ({
    ready: false,
    step: FeedbackStep.Role,
    surveyType: FeedbackSurveyType.AfterLessonFeedback,
    role: null,
    rating: null,
    classroomRating: null,
    tutorTransitionRating: null,
    detailedFeedback: '',
    category: null,
    selectedIssues: [],
    comment: '',
    commentError: false,
    additionalPractice: null,
    booking: null,
    options: null,
    discipline: null,
  }),
  actions,
  getters,
})
